import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ng2-tooltip-directive';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventsClassifications } from '../../Models/events';
import { UtilityService } from '../../services/utility.service';
import { Observable } from 'rxjs';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CategoriesComponent } from '../categories/categories.component';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgFor
    , BsDatepickerModule, TooltipModule, AutocompleteLibModule, NgMultiSelectDropDownModule, CategoriesComponent
    ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.css'
})
export class SummaryComponent {
  reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  });
  @ViewChild('datepickerInput', { static: false }) datepicker!: BsDatepickerDirective;

  caseName: string = '';
  startDate: Date = new Date();
  DateSelectedForFilter: Date = new Date();
  bsConfig!: Partial<BsDatepickerConfig>;
  classificationList: EventsClassifications[] = [];
  vehiclesList: any[]=[];
  FleetId = localStorage.getItem('FleetId');
  fleetList: any[] = [];
  selectedFleet: any;
  selectedFleetForFilter: any;
  selectedFleet1: any;
  selectedFleet2: any;
  selectedCategory: string='';
  selectedDeviceIdentifier: string='';
  selectedVRNForFilters: string='';
  selectedVRN: string='';
  selectedCategoryForFilter: string = '';
  caseDateSelected: Date = new Date();
 /* DateSelectedForFilter: any;
  startDate = new Date();*/
  maxDate: string = '';
  loading: boolean = false;
  bsCaseDateConfig!: Partial<BsDatepickerConfig>;
  uploadedFiles: File[] = [];
  isDragging = false;
  alertId: string = '';
  assetsSelected :boolean = false;
  mediaSelected: boolean = false;
  nodeSelected: boolean = false;
  showSummaryComp: boolean = true;

  fleetDropdownSettings: IDropdownSettings = {};
  eventHours = '';
  eventMinutes = '';
  eventSeconds = '';

  mediaTypes = [
    { label: 'Assets', value: 'assets', icon:'far fa-folders' },
    { label: 'Media', value: 'media', icon: 'far fa-photo-video' },
    { label: 'Node', value: 'node', icon: 'fal fa-folder-plus' }
  ];
  vrnList: any;

  requestVRN = '';
  selectedMediaType = 'assets';
  selectedUploadMethod = 'upload';
  requestDate: string = '';
  requestTime: string = '';

  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  minutes: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  seconds: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  constructor(private utility: UtilityService, private http: HttpClient,
    private toaster: ToastrService, private titleService: Title) {
   
    const today = new Date();
      this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      isAnimated: true,
      showWeekNumbers: false,
      maxDate: today 
    };
    this.bsCaseDateConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      isAnimated: true,
      showWeekNumbers: false,
      maxDate: today
    };
  }

  ngOnInit(): void {
    this.alertId = '';
    this.getEventsClassifications();
    this.getFleetVehicles(this.FleetId);
    this.loadFleetList(0);

    this.fleetDropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Name',
      allowSearchFilter: true,
      itemsShowLimit: 7,
      enableCheckAll: true,
    };
   // this.selectedFleet = this.FleetId;
  }

  getEventsClassifications() {
    this.loading = true;
    this.utility.getEventClassifications(this.FleetId).subscribe((data: any) => {
      this.classificationList = data;
      this.loading = false;
      this.classificationList = data.map(item => ({
        ...item,
        iconClass: this.getIconClass(item.Classification),
        statusClass: this.getStatusClass(item.Classification)
      }));
   // console.log(this.classificationList);
    });

  }

  getFleetVehicles(Id) {
    this.loading = true;
    this.utility.getVehicles(this.FleetId, (vehicles) => {
      const fleetVehicles = vehicles.filter(v => v.FleetId == this.FleetId);
      this.vehiclesList = fleetVehicles;
      this.vrnList = fleetVehicles;
      this.requestVRN = this.vrnList[0]?.DeviceIdentifier || '';
 /*     const allowedVrns = ['DX19XGL', 'FP68YGV'];
      this.vehiclesList = vehicles
        .filter(v => allowedVrns.includes(v.VRN))
        .map(v => ({
          VRN: v.VRN,
          VehicleId: v.VehicleId,
          FleetId: v.FleetId,
          FleetName: v.FleetName,
          DeviceIdentifier: v.DeviceIdentifier
        }));*/
      this.loading = false;
      this.selectedVRN = this.vehiclesList[0]?.DeviceIdentifier || '';
      //console.log(this.selectedVRN);
    });
  }
  loadFleetList(id:number) {
    this.loading = true;
    this.utility.getFleetList(id).subscribe({
      next: (data: any[]) => {
        //this.selectedFleet = data;
        this.loading = false;
        this.fleetList = data.filter(item => item.StatusId !== 4);
        this.selectedFleet = this.fleetList.find(item => item.Id == this.FleetId);
        this.selectedFleet1 = this.fleetList.find(item => item.Id == this.FleetId);
        this.selectedFleet = this.FleetId;
        this.selectedFleetForFilter = this.FleetId;
       // console.log(this.fleetList);
      },
      error: err => {
        console.error('Error fetching fleet list:', err);
      }
    });
  }
 

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }


  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer?.files?.length) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.addFiles(input.files);
    }
  }




  addFiles(fileList: FileList): void {
    Array.from(fileList).forEach(file => {    
      if (!this.uploadedFiles.some(f => f.name === file.name && f.size === file.size)) {
        this.uploadedFiles.push(file);
      }
    });
  }

  clearFiles(): void {
    this.uploadedFiles = [];
  }


  onInputChange(event: Event) {
    if (typeof this.alertId !== 'string') {
      this.alertId = '';
    }
    const input = (event.target as HTMLInputElement).value;
    this.alertId = input.replace(/[^0-9]/g, '');
  }
  get isFormValid(): boolean {
    return (
      this.selectedCategory &&
      this.caseDateSelected &&
      this.selectedVRN &&
      this.alertId.trim() !== ''
    );
  }

  submitForm() {
  //  console.log('Submit method called:');
   /* const payload = {
      categoryId: this.selectedCategory,
      caseDate: this.caseDateSelected,
      deviceIdentifier: this.selectedDeviceIdentifier,
      alertId: `#${this.alertId}`,
      mediaTypes: {
        assets: this.assetsSelected,
        media: this.mediaSelected,
        node: this.nodeSelected
      },
      files: this.uploadedFiles 
    };

    console.log('Payload to send:', payload);*/

    const eventObj: any = {};
    eventObj.FleetId = this.selectedFleet;
    eventObj.DeviceIdentifier = this.selectedVRN;
    eventObj.EventType = { "TypeId": 286, "Name": "FNOL_Incidents" } ;
    eventObj.Address = null;
    eventObj.Speed = 0;
   // eventObj.ClassificationTypeId = this.selectedCategory;
    //eventObj.VRN = ;
    const selectedDate = formatDate(this.caseDateSelected, 'yyyy-MM-dd', 'en-US');
    const hours = this.eventHours?.padStart(2, '0') || '00';
    const minutes = this.eventMinutes?.padStart(2, '0') || '00';
    const seconds = this.eventSeconds?.padStart(2, '0') || '00';

    const fullDateTime = `${selectedDate}T${hours}:${minutes}:${seconds}`;
    eventObj.EventDate = fullDateTime;
    //console.log('Payload to send:', eventObj);

  
/* obj.Lattitude = this.f.Lattitude.value;
    obj.Longitude = this.f.Longitude.value;
    obj.DeviceIdentifier = this.f.DeviceIdentifier.value;
    obj.FleetId = this.createManIncFleetId;
    obj.EventType = JSON.parse(this.f.EventType.value);
    obj.Severity = this.f.severity.value;
    obj.Speed = 0;
    obj.Address = null;
    obj.Status = status;
    obj.EventDate = formatDate(this.f.EventDate.value, 'yyyy-MM-dd', this.locale) + "T" + this.f.event_hours.value + ":" + this.f.event_min.value + ":" + this.f.event_sec.value;
    obj.VideoStatus = this.f.videostatus.value;
    obj.ChannelCount = this.vehiclesByFleet.find(item => item.DeviceIdentifier == obj.DeviceIdentifier).ChannelCount;*/
    return this.http.post(environment.API_URL + "SaveEventData/", eventObj, { headers: this.reqHeader })
      .subscribe(
        (data: any) => {
          console.log(data);
        },
        error => {
          console.log("Error", error);
        
        }
      );
  }
  closeCaseModal() {
    this.selectedCategory = '';
    this.caseDateSelected = new Date();
    this.selectedDeviceIdentifier = '';
    this.alertId = '';
    this.uploadedFiles = [];
    this.assetsSelected = false;
    this.mediaSelected = false;
    this.nodeSelected = false;
    this.isDragging = false;
  }
  
  openAddNewCaseModal() {
    this.selectedVRN = '';
  }
  getIconClass(classification: string): string {
    const map = {
      'Accident  (RTC)': 'far fa-car-crash',
      'Incident  (Near Miss)': 'far fa-bells',
      'Dismissed': 'fa-ban',
      'Intervention': 'fa-hands-helping',
      'Un Assigned': 'fa-question-circle',
      'Near Miss': 'fa-exclamation-triangle',
      'Complaints': 'far fa-comment-exclamation',
      'Training': 'fa-chalkboard-teacher',
      'Environmental': 'fa-leaf',
      'Conduct': 'fa-user-check'
    };
    return map[classification] || 'fa-circle';
  }
  getStatusClass(classification: string): string {
    const map = {
      'Accident  (RTC)': 'cat_accident',
      'Incident  (Near Miss)': 'cat_incedent',
      'Dismissed': 'cat_dismissed',
      'Intervention': 'cat_intervention',
      'Un Assigned': 'cat_unssigned',
      'Near Miss': 'status_blue',
      'Complaints': 'cat_complaints',
      'Training': 'cat_training',
      'Environmental': 'cat_environ',
      'Conduct': 'cat_conduct'
    };
    return map[classification] || 'status_gray';
  }

  getBackgroundClass(classification: string): string {
    const map = {
      'Incident': 'bg-incident',
      'Accident': 'cat_accident',
      'Dismissed': 'bg-dismissed',
      'Intervention': 'bg-intervention',
      'Un Assigned': 'bg-unassigned',
      'Near Miss': 'bg-nearmiss',
      'Complaints': 'bg-complaints',
      'Training': 'bg-training',
      'Environmental': 'bg-environmental',
      'Conduct': 'bg-conduct'
    };
    return map[classification] || 'bg-default';
  }



  activeCategory: string | null = null;

  onCategoryClick(category: string) {
    this.activeCategory = category;
    this.showSummaryComp = false;
   // console.log(this.activeCategory);
  }
  positionDatepickerRight() {
    setTimeout(() => {
      const datepicker = document.querySelector('.bs-datepicker-container') as HTMLElement;
      const input = document.querySelector('input[bsdatepicker]') as HTMLElement;

      if (datepicker && input) {
        const rect = input.getBoundingClientRect();
        datepicker.style.position = 'fixed';
        datepicker.style.left = rect.right + 10 + 'px';
        datepicker.style.top = rect.top + 'px';
        datepicker.style.zIndex = '1060';
      }
    }, 50); // Give time for popup to render
  }
  goToCategories(): void {
    this.showSummaryComp = true;
   // this.router.navigate(['/home/incidents-events']);
  }
/*
  ngAfterViewInit() {
    this.datepicker.onShown.subscribe(() => {
      setTimeout(() => {
        const dp = document.querySelector('.bs-datepicker-container') as HTMLElement;
        const input = document.querySelector('input[bsdatepicker]') as HTMLElement;

        if (dp && input) {
          const inputRect = input.getBoundingClientRect();
          const dpHeight = dp.offsetHeight || 300;

          // Don't force immediate changes – wait for animation
          requestAnimationFrame(() => {
            dp.style.position = 'fixed';
            dp.style.zIndex = '1060';
            dp.style.left = `${inputRect.left}px`;
            dp.style.top = `${inputRect.top - dpHeight - 10}px`; // display above
          });
        }
      }, 150); // Ensure popup is fully mounted before positioning
    });
  }*/
  ngOnDestroy() {
    this.loading = false;
    this.showSummaryComp = true;
    this.caseDateSelected = new Date();
  }
  onDataSelect(item: any, val: string) {
    if (val == "fleet") {
      let fleetIndex = this.selectedFleet1.findIndex((obj: any) => obj.Id == item.Id);
      if (fleetIndex == -1) {
        this.selectedFleet1.push(item);
      }
    }
  }
  onDataUnSelect(item: any, val: string) {
    if (val == "fleet") {
      this.selectedFleet = this.selectedFleet.filter((selectedFleet: any) => selectedFleet.Id !== item.Id);

    }
   
  }
  onSelectAll(items: any, val: string) {
    if (val == "fleet") {
      this.selectedFleet = items.slice();
    }

  }
  onFleetSelectionChange() {

  }
  onUnSelectAll(val: string) {

    if (val == "fleet") {
      this.selectedFleet = [];
    }
  }
 
  selectMediaType(type: string): void {
    this.selectedMediaType = type;
    if (type === 'media') {
      this.selectedUploadMethod = 'alert';
    } else {
      this.selectedUploadMethod = 'upload';
    }
  }
}
